export const HOME_PATH = '/';
export const STATIC_PAGE_TERMS_PATH = '/terms';
export const STATIC_PAGE_PRIVACY_PATH = '/privacy';
export const STATIC_PAGE_LEGAL_NOTICE_PATH = '/legal-notice';
export const SITE_EVENT_DETAIL_PATH = '/events/:eventId';
export const SITE_ORGANIZATION_LIST_PATH = '/events/:eventId/organizations';
export const SITE_ORGANIZATION_DETAIL_PATH = '/events/:eventId/organizations/:organizationId';
export const SITE_USER_LIST_PATH = '/events/:eventId/users';
export const SITE_USER_DETAIL_PATH = '/events/:eventId/users/:userId';
export const SITE_JOB_LIST_PATH = '/events/:eventId/jobs';
export const SITE_JOB_DETAIL_PATH = '/events/:eventId/jobs/:jobId';
export const SITE_SESSIONS_LIST_PATH = '/events/:eventId/sessions';
export const SITE_SESSIONS_DETAIL_PATH = '/events/:eventId/sessions/:sessionId';
export const SITE_PAGE_DETAIL_PATH = '/events/:eventId/pages/:pageId';
export const SITE_MESSAGES_PATH = '/events/:eventId/messages';
export const SITE_CONVERSATION_ADD_PATH = '/events/:eventId/messages/add';
export const SITE_CONVERSATION_DETAIL_PATH = '/events/:eventId/messages/:conversationId';
export const SITE_TERMS_PATH = '/terms';
